module.exports = __webpack_public_path__ + "static/media/31.f9512d7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/31.jpg
// module id = 592
// module chunks = 0